module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#twitter",
      toString: function () {
        return this.url;
      }
    }